import { render, staticRenderFns } from "./deviceCheck.vue?vue&type=template&id=4aa197c0&scoped=true&"
import script from "./deviceCheck.vue?vue&type=script&lang=js&"
export * from "./deviceCheck.vue?vue&type=script&lang=js&"
import style0 from "./deviceCheck.vue?vue&type=style&index=0&id=4aa197c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa197c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa197c0')) {
      api.createRecord('4aa197c0', component.options)
    } else {
      api.reload('4aa197c0', component.options)
    }
    module.hot.accept("./deviceCheck.vue?vue&type=template&id=4aa197c0&scoped=true&", function () {
      api.rerender('4aa197c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/deviceCheck.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/deviceCheck.vue
// module id = 9KJf
// module chunks = 0